export const onBoarding = (
    modalNextStep: HTMLButtonElement, 
    modalPreviousStep: HTMLButtonElement, 
    modalFirstStep: HTMLElement, 
    modalSecondStep: HTMLElement, 
    modalThirdStep: HTMLElement,
    onboardingTitle: HTMLElement,
    btnsContainer: HTMLElement,
    modal: HTMLElement
    ) => {

        let step = 1

        modal && modal.classList.add("open");

        if (modalNextStep) {
            modalNextStep.addEventListener('click', () => {
                switch(step) {
                    case 1:
                        modalFirstStep.style.display = 'none'
                        modalSecondStep.style.display = 'flex'
                        modalPreviousStep.style.display = 'block'
                        btnsContainer.style.justifyContent = 'space-between'
                        onboardingTitle.innerText = "Comment gagner des points ?"
                        step = 2
                        break
                    case 2:
                        modalSecondStep.style.display = 'none'
                        modalThirdStep.style.display = 'flex'
                        onboardingTitle.innerText = "Quelques informations à connaître avant de commencer :"
                        modalNextStep.innerText = "Commencer"
                        step = 3
                        break
                    case 3:
                        modal.classList.remove("open");
                        localStorage.setItem('isOnboardingDone', 'true')

                }
            })
        }

        if (modalPreviousStep) {
            modalPreviousStep.addEventListener('click', () => {
                switch(step) {
                    case 2:
                        modalFirstStep.style.display = 'flex'
                        modalSecondStep.style.display = 'none'
                        modalPreviousStep.style.display = 'none'
                        btnsContainer.style.justifyContent = 'end'
                        onboardingTitle.innerText = "Bienvenue"
                        step = 1
                        break
                    case 3:
                        modalSecondStep.style.display = 'flex'
                        modalThirdStep.style.display = 'none'
                        onboardingTitle.innerText = "Comment gagner des points ?"
                        modalNextStep.innerText = "Suivant"
                        step = 2
                        break
                }
            })
        }
}